import { _ as _call_super } from "@swc/helpers/_/_call_super";
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _inherits } from "@swc/helpers/_/_inherits";
import { _ as _wrap_native_super } from "@swc/helpers/_/_wrap_native_super";
export var LoginError = /*#__PURE__*/ function(Error1) {
    "use strict";
    _inherits(LoginError, Error1);
    function LoginError(message, httpStatusCode, responseBody) {
        _class_call_check(this, LoginError);
        var _this;
        _this = _call_super(this, LoginError, [
            message
        ]);
        _this.httpStatusCode = httpStatusCode;
        _this.responseBody = responseBody;
        return _this;
    }
    return LoginError;
}(_wrap_native_super(Error));
